import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useDtAccountStatus() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb);

  // Status whether account has KYC-ed for Day Trading
  const isDtActive = data?.odt_status === 'ACTIVE';

  // Status whether account is currently suspended for DT trading
  const isDtBuySuspended = data?.trade_buy_status === 'SUSPEND_BUY';
  const isDtSellSuspended = data?.trade_sell_status === 'SUSPEND_SELL';

  // Status for DT trading hours
  const isDtBuyTradingHourEnd = data?.trade_buy_status === 'FC_SUSPEND_BUY';
  const isDtSellTradingHourEnd = data?.trade_sell_status === 'FC_SUSPEND_SELL';
  const isDtInProcess = data?.odt_status === 'IN_PROCESS';

  return {
    data,
    isSuccess,
    isDtActive,
    isDtBuySuspended,
    isDtSellSuspended,
    isDtBuyTradingHourEnd,
    isDtSellTradingHourEnd,
    isDtInProcess,
    refetch,
  };
}

export default {
  useDtAccountStatus,
};
